import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { DATA_GRID_YES_NO_OPTIONS } from 'constants/components';

const styles = {
  typography: ({ palette, breakpoints }, value) => ({
    width: 64,
    height: 24,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    backgroundColor: value === DATA_GRID_YES_NO_OPTIONS.YES ? palette.colors.statusGreen : palette.colors.statusRed,
    [breakpoints.up('md')]: {
      height: 36,
    },
  }),
};

const TableBooleanValue = ({ value }) => (
  <Typography
    variant="body2-bold"
    component="span"
    color="text.secondary"
    sx={(theme) => styles.typography(theme, value)}
  >
    {value}
  </Typography>
);

TableBooleanValue.propTypes = {
  value: PropTypes.oneOf(Object.values(DATA_GRID_YES_NO_OPTIONS)).isRequired,
};

export default TableBooleanValue;
